import { Image } from "@mantine/core";

export type ISvgToIconProps = {
  icon: string;
  size?: number;
  className?: string;
  alt?: string;
  title?: string;
  onClick?: () => void;
};

const SvgToIcon = ({
  icon,
  size = 45,
  className,
  ...rest
}: ISvgToIconProps) => {
  const iconName =
    icon.split("/").pop()?.split(".")[0].replaceAll("-", " ") ?? icon;

  return (
    <Image
      {...rest}
      alt={rest.alt ?? `Icône de ${iconName}`}
      className={`inline-block ${className}`}
      fit="contain"
      loading="lazy"
      mah={"fit-content"}
      src={icon}
      title={rest.title ?? `Icône de ${rest.alt ?? iconName}`}
      w={size}
    />
  );
};

export default SvgToIcon;
